export enum NewPasswordControlName {
  CurrentPassword = 'currentPassword',
  NewPassword = 'newPassword',
  PasswordConfirmation = 'passwordConfirmation'
}

export enum CustomFormError {
  NotSamePasswords = 'notSamePasswords'
}
